import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";

import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { CustomNumberPipe } from "./pipe/custom-number.pipe";

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: [CustomNumberPipe],
	exports: [TranslateModule, CommonModule, FormsModule, CustomNumberPipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
